import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '@app/material/material.module';

import { ButtonModule } from '@shared/components/button/button.module';
import { DataGridModule } from '@shared/components/data-grid/data-grid.module';

import { GenerateDocumentsDialogComponent } from './generate-documents-dialog.component';
// tslint:disable-next-line:max-line-length
import { AnswerSetHeaderDetailsComponent } from '@app/features/answer-set/components/answer-set-header-details/answer-set-header-details.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    DataGridModule,
    MaterialModule
  ],
  declarations: [GenerateDocumentsDialogComponent],
  exports: [GenerateDocumentsDialogComponent],
  entryComponents: [GenerateDocumentsDialogComponent]
})
export class GenerateDocumentsDialogModule { }
